/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigningOtpResponseDto
 */
export interface SigningOtpResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SigningOtpResponseDto
     */
    signingSessionId: string;
    /**
     * Whether the SMS OTP was sent successfully
     * @type {boolean}
     * @memberof SigningOtpResponseDto
     */
    smsSent: boolean;
}

/**
 * Check if a given object implements the SigningOtpResponseDto interface.
 */
export function instanceOfSigningOtpResponseDto(value: object): value is SigningOtpResponseDto {
    if (!('signingSessionId' in value) || value['signingSessionId'] === undefined) return false;
    if (!('smsSent' in value) || value['smsSent'] === undefined) return false;
    return true;
}

export function SigningOtpResponseDtoFromJSON(json: any): SigningOtpResponseDto {
    return SigningOtpResponseDtoFromJSONTyped(json, false);
}

export function SigningOtpResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningOtpResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'signingSessionId': json['signingSessionId'],
        'smsSent': json['smsSent'],
    };
}

export function SigningOtpResponseDtoToJSON(json: any): SigningOtpResponseDto {
    return SigningOtpResponseDtoToJSONTyped(json, false);
}

export function SigningOtpResponseDtoToJSONTyped(value?: SigningOtpResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signingSessionId': value['signingSessionId'],
        'smsSent': value['smsSent'],
    };
}

